import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
@Component({
  selector: "ngx-unit-form",
  templateUrl: "./hrm-acc-voucher-date-form.component.html",
  styleUrls: ["./hrm-acc-voucher-date-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HrmAccVoucherDateFormComponent extends BaseFormComponent<any> {
  deactivateSave: boolean = false;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  erroremessage: string;
  async ngOnInit() {
    await this.setColumns();
  }
  async setColumns() {
    this.orignalColumns = [];
    this.orignalColumns.push(<form_control>{
      label: "تاریخ سند",
      controlType: FormControlTypes.datePicker,
      modelName: "VoucherDate",
      disabled: false,
      name: "VoucherDate",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
    });
    this.orignalColumns.push(<form_control>{
      label: "شعه",
      controlType: FormControlTypes.dropdown,
      modelName: "BranchId",
      disabled: false,
      name: "BranchId",
      order: 1,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
      apiName: "Branch/ReadLookUp",
      valueMember: "Id",
      displayMember: "Title",
    });
    this.model = {};
    this.model.VoucherDate = new Date();
    this.model.BranchId = this.accountService.authService.currentBranchId;
    this.columns = this.orignalColumns;
    this.setFormGroup(this.model);
  }
  addControl() {
    this.cd.markForCheck();
  }
  async save() {
    this.selectorService.submitted$.next(this.submitted);
    this.result = this.getDataFromFormGroup();
    this.closeModal();
  }
}
